window.cspFontFamilyUtils = {
    getFont: (fonts, fontCode) => {
        return fonts.find(f => f.code === fontCode) || fonts[0];
    },
    fonts: [
        {
            code: "Open+Sans",
            family: '"Open Sans", sans-serif',
            label: "Open Sans",
            link: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap"
        },
        {
            code: "Glegoo",
            family: '"Glegoo", serif',
            label: "Glegoo",
            link: "https://fonts.googleapis.com/css2?family=Edu+AU+VIC+WA+NT+Hand:wght@400..700&family=Glegoo:wght@400;700&display=swap"
        },
        {
            code: "Arvo",
            family: '"Arvo", serif',
            label: "Arvo",
            link: "https://fonts.googleapis.com/css2?family=Arvo:ital,wght@0,400;0,700;1,400;1,700&family=Edu+AU+VIC+WA+NT+Hand:wght@400..700&family=Glegoo:wght@400;700&display=swap"
        },
        {
            code: "Bona+Nova+SC",
            family: '"Bona Nova SC", serif',
            label: "Bona Nova SC",
            link: "https://fonts.googleapis.com/css2?family=Arvo:ital,wght@0,400;0,700;1,400;1,700&family=Bona+Nova+SC:ital,wght@0,400;0,700;1,400&family=Edu+AU+VIC+WA+NT+Hand:wght@400..700&family=Glegoo:wght@400;700&display=swap"
        },
        {
            code: "Noto+Serif+JP",
            family: '"Noto Serif JP", serif',
            label: "Noto Serif Japanese",
            link: "https://fonts.googleapis.com/css2?family=Arvo:ital,wght@0,400;0,700;1,400;1,700&family=Bona+Nova+SC:ital,wght@0,400;0,700;1,400&family=Edu+AU+VIC+WA+NT+Hand:wght@400..700&family=Glegoo:wght@400;700&family=Noto+Serif+JP:wght@200..900&display=swap"
        },
        {
            code: "Poppins",
            family: '"Poppins", sans-serif',
            label: "Poppins",
            link: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        },
        {
            code: "Rubik",
            family: '"Rubik", sans-serif',
            label: "Rubik",
            link: "https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap"
        },
        {
            code: "Baloo+2",
            family: '"Baloo 2", sans-serif',
            label: "Baloo 2",
            link: "https://fonts.googleapis.com/css2?family=Baloo+2:wght@400..800&display=swap"
        },
        {
            code: "Patrick+Hand",
            family: '"Patrick Hand", cursive',
            label: "Patrick Hand",
            link: "https://fonts.googleapis.com/css2?family=Patrick+Hand&display=swap"
        },
        {
            code: "Luckiest+Guy",
            family: '"Luckiest Guy", cursive',
            label: "Luckiest Guy",
            link: "https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap"
        },
        {
            code: "Gloria+Hallelujah",
            family: '"Gloria Hallelujah", cursive',
            label: "Gloria Hallelujah",
            link: "https://fonts.googleapis.com/css2?family=Gloria+Hallelujah&display=swap"
        },
        {
            code: "Anton",
            family: '"Anton", sans-serif',
            label: "Anton",
            link: "https://fonts.googleapis.com/css2?family=Anton&display=swap"
        },
        {
            code: "Josefin+Sans",
            family: '"Josefin Sans", sans-serif',
            label: "Josefin Sans",
            link: "https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap"
        },
        {
            code: "Bungee",
            family: '"Bungee", sans-serif',
            label: "Bungee",
            link: "https://fonts.googleapis.com/css2?family=Bungee&display=swap"
        },
        {
            code: "Black+Ops+One",
            family: '"Black Ops One", system-ui',
            label: "Black Ops One",
            link: "https://fonts.googleapis.com/css2?family=Black+Ops+One&display=swap"
        },
        {
            code: "Bebas+Neue",
            family: '"Bebas Neue", sans-serif',
            label: "Bebas Neue",
            link: "https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap"
        },
        {
            code: "Kalnia+Glaze",
            family: '"Kalnia Glaze", serif',
            label: "Kalnia Glaze",
            link: "https://fonts.googleapis.com/css2?family=Kalnia+Glaze:wght@100..700&display=swap"
        },
        {
            code: "Playwrite+CU",
            family: '"Playwrite CU", cursive',
            label: "Playwrite Cuba",
            link: "https://fonts.googleapis.com/css2?family=Playwrite+CU:wght@100..400&display=swap"
        },
        {
            code: "Raleway",
            family: '"Raleway", sans-serif',
            label: "Raleway",
            link: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap"
        },
        {
            code: "Playwrite+HR+Lijeva",
            family: '"Playwrite HR Lijeva", cursive',
            label: "Playwrite Hrvatska Lijeva",
            link: "https://fonts.googleapis.com/css2?family=Playwrite+HR+Lijeva:wght@100..400&display=swap"
        },
        {
            code: "Edu+AU+VIC+WA+NT+Hand",
            family: '"Edu AU VIC WA NT Hand", cursive',
            label: "Edu Australia VIC WA NT Hand",
            link: "https://fonts.googleapis.com/css2?family=Edu+AU+VIC+WA+NT+Hand:wght@400..700&display=swap"
        },
        {
            code: "Quicksand",
            family: '"Quicksand", sans-serif',
            label: "Quicksand",
            link: "https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap"
        },
        {
            code: "Playwrite+BE+VLG",
            family: '"Playwrite BE VLG", cursive',
            label: "Playwrite België Vlaams Gewest",
            link: "https://fonts.googleapis.com/css2?family=Playwrite+BE+VLG:wght@100..400&display=swap"
        },
        {
            code: "Playfair+Display",
            family: '"Playfair Display", serif',
            label: "Playfair Display",
            link: "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap"
        },
        {
            code: "Oswald",
            family: '"Oswald", sans-serif',
            label: "Oswald",
            link: "https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap"
        },
        {
            code: "Outfit",
            family: '"Outfit", sans-serif',
            label: "Outfit",
            link: "https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap"
        },
        {
            code: "Yellowtail",
            family: '"Yellowtail", cursive',
            label: "Yellowtail",
            link: "https://fonts.googleapis.com/css2?family=Yellowtail&display=swap"
        },
        {
            code: "Bangers",
            family: '"Bangers", system-ui',
            label: "Bangers",
            link: "https://fonts.googleapis.com/css2?family=Bangers&display=swap"
        },
        {
            code: "Ubuntu",
            family: '"Ubuntu", sans-serif',
            label: "Ubuntu",
            link: "https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap"
        },
        {
            code: "Teko",
            family: '"Teko", sans-serif',
            label: "Teko",
            link: "https://fonts.googleapis.com/css2?family=Teko:wght@300..700&display=swap"
        },
        {
            code: "Figtree",
            family: '"Figtree", sans-serif',
            label: "Figtree",
            link: "https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&display=swap"
        }
    ]
};

Object.freeze(cspFontFamilyUtils);